<template>
  <v-text-field
    outlined
    v-model="number"
    :label="label"
    hide-details
    :max="max"
    :dense="dense"
    @keypress="isNumber($event)"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    max: {
      type: Number,
      default: null,
    },
    limit: {
      type: Number,
      default: 4,
    },
  },
  data: () => ({
    number: null,
  }),
  watch: {
    value () {
      this.prepareValue()
    },
    number (v) {
      const aux =  v ? v.replace(/\D/g, "") : v
      if (v !== aux) this.number = aux
      this.$emit('input', aux)
    },
  },
  mounted () {
    this.prepareValue()
  },
  methods: {
    prepareValue () {
      this.number = this.value ? this.value.replace(/\D/g, "") : null
    },
    isNumber (evt) {
      evt = (evt) ? evt : window.event
      const charCode = (evt.which) ? evt.which : evt.keyCode
      if (this.number.length >= this.limit) evt.preventDefault()
      else if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) evt.preventDefault()
      else return true
    }
  },
}
</script>


